<div *ngIf="point" class="ir-content-flow has-plugin" #scroll>
  <div class="ir-plugin th-plugin th-help" *ngIf="point?.description && showHelp" id="{{ point.id }}">
    <div class="ir-plugin-content" #plugin>
      <p class="ir-plugin-instruction">
        <span innerHtml="{{ point.description }}"></span>
      </p>
    </div>
  </div>
  <div class="plugin-container" *ngFor="let p of point.plugins | orderBy : 'order' | searchBy : query" #p.id>
    <div class="sessions">
      <ng-container *ngFor="let session of p?.sessions">
        <i
          *ngIf="session.user"
          [title]="session.user"
          class="material-icons"
          [style.color]="session.color"
          [class.disabled]="session.away"
          [class.away]="session.away"
          [class.active]="!session.away"
          >account_circle</i
        >
      </ng-container>
    </div>
    <ir-plugin [plugin]="p" [inspection]="point.inspection" #plugin></ir-plugin>
  </div>
  <div class="ir-item-empty ir-mv8" *ngIf="point.plugins?.length == 0">
    <p>
      <span>{{ 'points.no-plugins' | translate }}</span>
    </p>
  </div>
</div>
<div class="ir-position--b th-footer-plugins">
  <div class="ir-row">
    <div class="ir-cell-tin3 ir-cell-sma3 ir-cell-mid3 ir-cell-lar3" (click)="gotoNextPlugin()">
      <div class="ir-btn ir-btn--big ir-btn--block th-btn-footerplugin">
        <i class="material-icons">arrow_downward</i>
      </div>
    </div>
    <div class="ir-cell-tin3 ir-cell-sma3 ir-cell-mid3 ir-cell-lar3" (click)="gotoPreviousPlugin()">
      <div class="ir-btn ir-btn--big ir-btn--block th-btn-footerplugin">
        <i class="material-icons">arrow_upward</i>
      </div>
    </div>
    <div class="ir-cell-tin3 ir-cell-sma3 ir-cell-mid3 ir-cell-lar3" [routerLink]="getEditNotesRoute()">
      <div class="ir-btn ir-btn--big ir-btn--block" [ngClass]="point.notes ? 'th-btn-normal' : ''">
        <span>{{ 'points.my-notes' | translate }}</span
        ><span *ngIf="point.notes">&nbsp; &#9679;</span>
      </div>
    </div>
    <div class="ir-cell-tin3 ir-cell-sma3 ir-cell-mid3 ir-cell-lar3" [permissions]="[['visible', 'inspection.offline.edit', inspection]]">
      <button class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right" (click)="updateStatus()" *ngIf="!processing">
        <span *ngIf="point.status !== 200">{{ isDone() ? ('points.undone' | translate) : ('points.done' | translate) }}</span>
        <span *ngIf="point.status === 200">{{ 'points.restore' | translate }}</span>
      </button>
      <button class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right" type="submit" *ngIf="processing">
        <span>{{ 'common.processing' | translate }}</span>
      </button>
    </div>
  </div>
</div>
